import { Vue, Component, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { Moment } from 'moment'
import { EDGE_DATE } from '@/config'

@Component
export default class Daterange extends Vue {
  @State serverTime!: Moment

  longChecked = false // 截止日期是否为长期有效
  tempEndDate: string | null = null // 截止日期

  todayAndBefore(current: Moment) {
    return current && current <= this.serverTime.endOf('day')
  }

  todayAndAfter(current: Moment) {
    return current && current >= this.serverTime.startOf('day')
  }

  // setEndDate方法需要在组件内实现
  @Watch('longChecked')
  onLongCheckedChange(val: boolean) {
    if (val) {
      (this as any).setEndDate?.(EDGE_DATE)
      this.tempEndDate = null
    } else {
      (this as any).setEndDate?.(null)
    }
  }

  onEndDateChange(val: string) {
    if (val === EDGE_DATE) {
      this.longChecked = true
    } else {
      this.tempEndDate = val
    }
  }
}
